/**
 * @fileoverview Partner - model for a social post partner
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.provide('yext.social.post.CharacterLimitRule');
goog.provide('yext.social.post.Partner');

goog.require('yext.mvc.Model');

/**
 * @param {!Object} partner
 * @extends {yext.mvc.Model}
 * @constructor
 */
yext.social.post.Partner = function(partner) {
  yext.mvc.Model.call(this);

  partner = partner || {};

  /** @type {number} */
  this['id'] = partner['id'];

  /** @type {string} */
  this['name'] = partner['name'] || '';

  /** @type {string} */
  this['iconClass'] = partner['iconClass'] || '';

  /** @type {number} */
  this['minChars'] = partner['minChars'] || null;

  /** @type {number} */
  this['maxChars'] = partner['maxChars'] || null;

  /** @type {!Array<yext.social.post.PartnerFieldConfiguration.PostField>} */
  this['excludedFields'] = partner['excludedFields'] || [];

  /** @type {boolean} */
  this['isAvailable'] = true;

  /** @type {boolean} */
  this['isSelected'] = true;
};
goog.inherits(yext.social.post.Partner, yext.mvc.Model);

/**
 * NOTE(slanden): This enum should be kept up to date with PostField in PostPageView
 * @enum {string}
 */
yext.social.post.Partner.PostField = {
  PROFILE_FIELDS: 'PROFILE_FIELDS',
  EVENTS: 'EVENTS',
  CALL_TO_ACTION: 'CALL_TO_ACTION',
};

/** @enum {number} */
yext.social.post.Partner.PartnerId = {
  WIDGETS: 582,
  TWITTER: 689,
};

yext.social.post.Partner.prototype.getMaxChars = function(post) {
  return yext.social.post.CharacterLimitRule.RULES.filter(function(rule) {
    return this.get('id') == rule.getPartnerId()
           && yext.social.post.CharacterLimitRule.RuleType.MAX_CHARS == rule.getRuleType()
           && rule.ruleApplies(post);
  }.bind(this)).map(function(rule) {
    return rule.getRuleValue();
  }).reduce(function(a, b) {
    return Math.min(a, b);
  }, this.get('maxChars'));
};

/** @constructor */
yext.social.post.CharacterLimitRule = function(rule) {
  /**
   * @private
   * @type {number}
   */
  this.partnerId_ = rule.partnerId;

  /**
   * @private
   * @type {yext.social.post.CharacterLimitRule.RuleType}
   */
  this.ruleType_ = rule.ruleType;

  /**
   * @private
   * @type {number}
   */
  this.ruleValue_ = rule.ruleValue;

  /**
   * @private
   * @type {Function}
   */
  this.ruleApplies_ = rule.ruleApplies || function() {
    throw new Error('CharacterLimitRule: ruleApplies is not implemented yet');
  };
};

/** @enum {number} */
yext.social.post.CharacterLimitRule.RuleType = {
  MAX_CHARS: 1,
  MIN_CHARS: 2,
};

/**
 * @const
 * @type {!Array<yext.social.post.CharacterLimitRule>}
 */
yext.social.post.CharacterLimitRule.RULES = [
  // NOTE(slanden): There are no longer any special rules for any publishers. Leaving for future
];

/** @return {number} partnerId */
yext.social.post.CharacterLimitRule.prototype.getPartnerId = function() {
  return this.partnerId_;
};

/** @return {yext.social.post.CharacterLimitRule.RuleType} */
yext.social.post.CharacterLimitRule.prototype.getRuleType = function() {
  return this.ruleType_;
};

/** @return {number} */
yext.social.post.CharacterLimitRule.prototype.getRuleValue = function() {
  return this.ruleValue_;
};

/**
 * @param {!Object<string, ?>} post
 * @return {boolean} true if the rule should be applied to the given post
 */
yext.social.post.CharacterLimitRule.prototype.ruleApplies = function(post) {
  return this.ruleApplies_(post);
};
